

import axios from 'axios';
import { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { useNavigate } from 'react-router-dom';

function MyCarosal() {
    const [bannersList,setBannersList] = useState([])
     const navigate = useNavigate();
    useEffect(()=>{

        axios.post("https://gantasoft.in/dev/asvmall/banners/getbanners.php", {
           
                "main_id":"8989877hhftgh67"
                
        }).then((res)=>{
            if(Array.isArray(res.data)){
                setBannersList(res.data)
            }

        }).catch(e=>{
            console.log(e)
        })
    },[])
  return (
    <Carousel>
        {
            bannersList.map(e=> (
        
 
     <Carousel.Item className="p-3"  onClick={()=> navigate(`productsbySubCatId/${e.carousel_url}`)}>
        <img className='w-100 banner-img' src={e.carousel_image}/>
       
      </Carousel.Item>
            ))
}
      {/* <Carousel.Item>
      <img className='w-100 ' src="https://www.canva.com/design/DAGBWTpT5Ho/e-ACVy91nUmDs58-4hKJAQ/view?utm_content=DAGBWTpT5Ho&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"/>
       
      </Carousel.Item>
      <Carousel.Item>
      <img className='w-100 ' src="https://res.cloudinary.com/dlx1ggdog/image/upload/v1712136076/assvmall/Bannerimages/White_Minimalist_Profile_LinkedIn_Banner_1_cytax3.png"/>
      
      </Carousel.Item> */}
    </Carousel>
  );
}

export default MyCarosal;